import { render, staticRenderFns } from "./FormKcpContestInfoOrganizationSub.vue?vue&type=template&id=2a75410f&"
import script from "./FormKcpContestInfoOrganizationSub.vue?vue&type=script&lang=js&"
export * from "./FormKcpContestInfoOrganizationSub.vue?vue&type=script&lang=js&"
import style0 from "./FormKcpContestInfoOrganizationSub.vue?vue&type=style&index=0&id=2a75410f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports